import React, { type ReactNode } from "react";

const NBFC_NAME: string = import.meta.env.VITE_COMPANY_NBFC || "";
const NBFC_URL = "https://fintechcloud.com/";

export const NbfcLink: React.FC<{ className?: string }> = ({ className }) => (
  <a
    href={NBFC_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={className ?? "underline hover:text-[#CC1A1A]"}
  >
    {NBFC_NAME}
  </a>
);

const KEY_INFO =
  /([\w.+-]+@[\w-]+(?:\.[\w-]+)+|\b[6-9]\d{9}\b|(?<=Name: )[^|]+?(?=\s*\|)|\b\d{1,2}(?::\d{2})? ?[AP]M to \d{1,2}(?::\d{2})? ?[AP]M(?: \(Monday to Saturday\)| from Monday to Saturday)?|\bterms (?:and|&) conditions\b|\bprivacy policy\b|\bgrievance redressal officer\b|\bseven \(7\) business days\b|\b7 business days\b)/gi;

const keyInfoClass = "font-bold text-[#CC1A1A]";

// Bolds contact names, numbers, emails, hours and legal terms in policy text.
export const highlightKeyInfo = (text: ReactNode): ReactNode => {
  if (typeof text !== "string") return text;
  return text.split(KEY_INFO).map((part, i) => {
    if (i % 2 === 0) return <React.Fragment key={i}>{linkifyNbfc(part)}</React.Fragment>;
    if (part.includes("@")) return <a key={i} href={`mailto:${part}`} className={`${keyInfoClass} underline`}>{part}</a>;
    if (/^\d{10}$/.test(part)) return <a key={i} href={`tel:${part}`} className={`${keyInfoClass} underline`}>{part}</a>;
    return <strong key={i} className={keyInfoClass}>{part}</strong>;
  });
};

// Replaces every occurrence of the NBFC partner name in a string with a link to its website
export const linkifyNbfc = (text: ReactNode): ReactNode => {
  if (typeof text !== "string" || !NBFC_NAME || !text.includes(NBFC_NAME)) return text;
  const parts = text.split(NBFC_NAME);
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 && <NbfcLink />}
    </React.Fragment>
  ));
};
